import $ from 'jquery';

$(document).ready(function () {
  acfCardImageLinkBlock();
});

function acfCardImageLinkBlock() {
  $('.js-acf-card-image-link').each(function () {});
}
